import template from './deleteConfirmation.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $mdDialog,
      $mdMedia,
      $timeout,
      eventService,
      organizationService,
      organizationsService,
      uiService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      ctrl.initialize = () => {
        ctrl.destroyWatch = eventService.onDialogDeleteConfirmation((params) => {
          $mdDialog
            .show({
              targetEvent: params.event,
              locals: {
                selectedData: params.selectedData,
                organizationName: params.organizationName,
                toast: params.toast,
                docType: params.docType
              },
              template,
              controllerAs: '$ctrl',
              controller(selectedData, organizationName, toast, docType) {
                const self = this;
                self.selectedData = selectedData;
                self.toast = toast;
                self.docType = docType;
                self.organizationName = organizationName;
                self.orgName = '';
                self.isConfirmed = null;
                self.isOrganizationNameEqual = () =>
                  self.orgName?.toLowerCase() === self.organizationName?.toLowerCase();

                self.confirm = () => {
                  if (self.isConfirmed === true) {
                    $mdDialog.hide({
                      selectedData: self.selectedData,
                      toast: self.toast,
                      docType: self.docType
                    });
                  }
                };
                self.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((result) => {
              if (result.docType === '__global_organization') {
                ctrl.deletedOrganization(result.selectedData, result.toast);
                ctrl.onFinished({ data: result.selectedData });
              }
            });
        });
      };

      ctrl.deletedOrganization = (organization, toast) => {
        if (organization && organization.id) {
          organizationService.deleteOrganization({ id: organization.id }).then((result) => {
            if (result.status) {
              organizationsService.clearCache();
              uiService.toast({
                text: {
                  p1: organization.getName(),
                  p2: toast,
                  p3: 'has been deleted'
                },
                warn: false
              });
            } else {
              if (
                result.ancestors !== 0 &&
                result.subscription === null &&
                result.isEnterprise
              ) {
                uiService.toast({
                  text: {
                    p1: `${organization.getName()} ${toast}`,
                    p2: 'has groups and branches',
                    p3: 'and cannot be deleted'
                  },
                  warn: true
                });
              }
              if (
                result.ancestors === 0 &&
                result.subscription !== null &&
                !result.isEnterprise
              ) {
                uiService.toast({
                  text: {
                    p1: `${organization.getName()} ${toast}`,
                    p2: 'has active subscription',
                    p3: 'and cannot be deleted'
                  },
                  warn: true
                });
              }
            }
          });
        }
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
